import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onClick", "popoverProps", "shouldClose"],
  _excluded2 = ["onClose"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { AdTagStateless } from '@carnica/ui-kit';
import React, { forwardRef, useCallback, useEffect } from 'react';
import { compose } from '@beef/redux';
import { withDataConverter, withRenderFlag } from '@beef/react';
import { useFlag } from '@carnica/utils/hooks';
import { dataConverter } from "./utils";
/**
 * Компонент LegalBadge отображает рекламный бейдж.
 *
 * @param {ILegalBadgeProps} props - Свойства компонента.
 * @param {string} [props.direction='upLeft'] - Направление отображения бейджа.
 * @param {string} [props.text='реклама'] - Текст для бэйджа.
 * @param {string} [props.textBadge='рекламодатель — ПАО «ВымпелКом»'] - Текст для тултипа бэйджа.
 * @param {string} [props.color='tertiary-invert'] - Цвет текста.
 * @param {string} [props.theme='light'] - Тема оформления.
 * @param {string} [props.className=''] - Дополнительные CSS классы.
 * @param {string} [props.portalClassName=''] - CSS класс для портала шторки в моб версии.
 * @param {string} [props.tooltipClassName=''] - CSS класс для тултипа.
 * @param {boolean} [props.shouldClose=''] - флаг для контроля закрытия тултипа извне (внтури слайдера)
 * @param {HTMLElement} [props.containerRef] - реф контейнера для корректировки поведения
 * @returns {JSX.Element} - Возвращает JSX элемент.
 */

export var _LegalBadge = /*#__PURE__*/forwardRef(function (props, ref) {
  var onClick = props.onClick,
    popoverProps = props.popoverProps,
    shouldClose = props.shouldClose,
    otherProps = _objectWithoutProperties(props, _excluded);
  var _useFlag = useFlag(),
    _useFlag2 = _slicedToArray(_useFlag, 2),
    isOpen = _useFlag2[0],
    setIsOpen = _useFlag2[1];
  var handleClick = function handleClick(e) {
    setIsOpen.toggle();
    onClick === null || onClick === void 0 ? void 0 : onClick(e);
  };
  var _ref = popoverProps || {},
    onClose = _ref.onClose,
    otherPopoverProps = _objectWithoutProperties(_ref, _excluded2);
  var handleClose = useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    onClose === null || onClose === void 0 ? void 0 : onClose.apply(void 0, args);
    setIsOpen.off();
  }, [onClose]);
  // принудительно закрываем тултип по контролю извне (внутри слайдера)
  useEffect(function () {
    if (shouldClose) {
      setIsOpen.off();
    }
  }, [shouldClose]);
  return /*#__PURE__*/React.createElement(AdTagStateless, _extends({
    onClick: handleClick,
    popoverProps: _objectSpread({
      onClose: handleClose
    }, otherPopoverProps),
    ref: ref,
    tooltipOpen: isOpen
  }, otherProps, {
    "data-t-id": "components-LegalBadge"
  }));
});
export var LegalBadge = compose(withRenderFlag({
  shouldRenderFn: function shouldRenderFn(props) {
    return Boolean(props.text);
  }
}), withDataConverter(dataConverter))(_LegalBadge);